import { Collections } from "../constants/collections";
import { useFirebase } from "./useFirebase";

export default function useCollectionRef(collection: Collections) {
    const firestore = useFirebase().firestore();
    return firestore.collection(collection);
}